// +----------------------------------------------------------------------
// | Desc:微信场景封装
// +----------------------------------------------------------------------
// | Time:2021年10月25日 22:44
// +----------------------------------------------------------------------
import Vue from "vue";
import wxjssdk from "weixin-js-sdk";

// +----------------------------------------------------------------------
// | Desc:初始化sdk配置
// +----------------------------------------------------------------------
Vue.prototype.$wxJssdkShare = function (obj = {}) {
  let _this = this;
  //安卓机型获取当前页面路径
  let url = window.location.href;
  let shareurl = this.$config.h5 + "/setOsWxMessage";
  if (!this.$isblank(obj["link"])) {
    shareurl = obj["link"];
  }

  //自定义分享
  if (this.$isblank(obj["title"])) {
    obj["title"] = "万知达专利消息通知绑定";
  }
  if (this.$isblank(obj["desc"])) {
    obj["desc"] = "通过公众号接收专利通知消息更便捷";
  }
  obj["link"] = shareurl;
  if (this.$isblank(obj["imgUrl"])) {
    obj["imgUrl"] = this.$config.h5 + "/static/images/logo.png";
  }

  _this.$api
    .getJssdkConfig({
      url: url,
    })
    .then((res) => {
      if (res.data.code == 0) {
        let result = res.data.data;
        wxjssdk.config({
          debug: false,
          appId: result.appId,
          timestamp: result.timestamp,
          nonceStr: result.nonceStr,
          signature: result.signature,
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
        });
        wxjssdk.ready(() => {
          wxjssdk.updateAppMessageShareData({
            title: obj["title"], // 标题
            desc: obj["desc"], // 分享描述
            link: obj["link"], //分享链接
            imgUrl: obj["imgUrl"], // 分享图标
            success: () => {
              // 设置成功
            },
          });
          wxjssdk.updateTimelineShareData({
            title: obj["title"], // 标题
            desc: obj["desc"], // 分享描述
            link: obj["link"], //分享链接
            imgUrl: obj["imgUrl"], // 分享图标
            success: function () {
              // 设置成功
            },
          });
        });
      } else {
        _this.$msg(res.data.msg);
      }
    });
};

//微信交换code=====================================
Vue.prototype.$getWxCode = function () {
  let _this = this;
  let local = this.$config.h5+"/setOsWxMessage"; //模拟记得加HTPP
  let appid = "wx5b31fdbbe52f8153";
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`;
};

//微信交换code测试=====================================
Vue.prototype.$getWxCodeTest = function () {
  let local = "https://wzdip.com/setOsWxMessage"; //模拟记得加HTPP
  let appid = "wx5b31fdbbe52f8153";
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`;
};
